import React from 'react';

const IconBackArrow = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'>
        <path stroke='#3A3C3F' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M19 12H5M12 19l-7-7 7-7' />
    </svg>
);

export default IconBackArrow;
